import {store} from '../../store';
import authService from '../../../services/authService';
import {setCurrentUser} from './actions';
import {getCookie} from "typescript-cookie";

const sleep = (ms: number) => new Promise(res => setTimeout(res, ms));

export async function refreshCurrentUser(
    attempts = 6,
    delayMs = 1200
) {
    let user: any = null;

    for (let i = 0; i < attempts; i++) {
        try {
            const res = await authService.getProfile();
            user = res.data;

            store.dispatch(setCurrentUser(user));

            const roleType = getCookie('roleType') || user?.roles?.[0]?.roleType;

            const currentRole = Array.isArray(user?.roles) ? user.roles.find((r: any) => r.roleType === roleType) : null;

            if (currentRole?.isActive) {
                return user;
            }
        } catch {
        }

        await sleep(delayMs);
    }

    return user;
}